/**
 * Typed wrappers for the custom super-admin CRM-connection actions:
 * connectivity test + per-company capability probe.
 *
 * CRM-connection CRUD lives on the nested `/v1/superadmin/crm/connections`
 * path, which does NOT fit the flat `/{resource}` dataProvider shape, so the
 * CRM pages call `superadminFetch` against the explicit path directly (see the
 * CRM resource group). These two custom verbs are wrapped here.
 *
 * Backend reality (viq-backend/functions-superadmin/src/handlers/crmConnections.ts):
 *  - test   → `{ status: 'ok' | 'error'; message: string }`  (NOT `{ ok }`)
 *  - caps   → `{ salesforce: { connected: boolean } }`        (NOT `{ objects, canWrite }`)
 */
import { superadminFetch } from './dataProvider';

export interface TestConnectionResult {
  status: 'ok' | 'error';
  message: string;
}

/** POST /v1/superadmin/crm/connections/{id}/test — probes the stored connection. */
export async function testConnection(
  id: string,
): Promise<TestConnectionResult> {
  return superadminFetch<TestConnectionResult>(
    `/v1/superadmin/crm/connections/${id}/test`,
    { method: 'POST' },
  );
}

export interface CrmCapabilities {
  salesforce: { connected: boolean };
}

/** GET /v1/superadmin/crm/capabilities?companyId= — is this tenant CRM-connected? */
export async function crmCapabilities(
  companyId: string,
): Promise<CrmCapabilities> {
  return superadminFetch<CrmCapabilities>(
    `/v1/superadmin/crm/capabilities?companyId=${encodeURIComponent(companyId)}`,
  );
}
